const answerData = [
    {
        "id": 1,
        "name": "강다현",
        "text": "안됩니다. 그렇게 드시면 위험해요!!"
    },
    {
        "id": 2,
        "name": "박시현",
        "text": "너 그러다가 건강 큰일난다~ 제대로 먹어라~"
    },
    {
        "id": 3,
        "name": "양인서",
        "text": "그냥 니 알아서 먹어 ㅋ"
    },
    {
        "id": 4,
        "name": "오유진",
        "text": "그렇게 드시면 안되는데.. 누가 그렇게 드시나요?"
    }
]

export default answerData;